export default {
  name: 'app-footer',
  data () {
    return {
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/partials/app-footer/index.js